import React, { useEffect, useState, useRef }  from 'react';
import useCurrentUser from 'hooks/useCurrentUser'
import { Redirect } from 'react-router-dom'

export default ({ location: { search }, match }) => {
  const [redirectTo, setRedirectTo] = useState(null)
  const taskId = match.params.taskId

  useEffect(() => {
    if (!taskId) {
      return
    }

    // @TODO This could/should be a faster API call. For now, this solves the
    // problem by querying the API twice.

    fetch(`/rest/v2/task/${taskId}`)
      .then((response) => response.json())
      .then(({ data: { parenttask, orderid } }) => [parenttask, orderid])
      .then(([versionId, orderId]) =>
        fetch(`/rest/v2/task/${versionId}`)
        .then((response) => response.json())
        .then(({ data: { parenttask } }) => parenttask)
        .then((jobId) => setRedirectTo(
          `/orders/${orderId}/jobs/${jobId}/versions/${versionId}/tasks/${taskId}`
        ))
      )
  }, [taskId])

  if (redirectTo) {
    return (
      <Redirect to={redirectTo} />
    )
  }

  return null
}
